module.exports = __webpack_public_path__ + "static/media/lux-windows.c67c9ede.jpg";